<script>
    import _        from 'lodash'
    import { fly }  from 'svelte/transition'
    import * as api from '../../shared/api.js'
    import Modal    from '../../shared/SemanticModal.svelte'
    
    export let domain
    export let transitions
    export let status
    export let loading = true
    
    

    let copy = {
        id      : 0,
        enabled : false,
        url     : "",
        header  : "",
        token   : "",
        status  : status
    }
    
    let active  = false
    let working = false
    let updateError = false

    function cancel() {
        working = false
        active  = false
        updateCopy(original)
    }

    function updateCopy(it) {
        if(it)
            copy = _.cloneDeep(it)
    }

    function descriptionGiven(it) {
        switch(it.status) {
            case "CREATED"        : return "Transição automática para novos pedidos"
            case "IDENTIFIED"     : return "Execução automática dos pedidos identificados"
            case "REPORT SUCCESS" : return "Liberação automática de relatórios disponíveis"
            default               : return "Sem descrição"
        }
    }

    function updateTransition() {
        working = true
        return api
            .post(`/inquiries/domain/${domain.id}/settings`, copy)
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                active  = false
                original = copy
            })
            .catch(err => {
                working     = false
                updateError = err
                setTimeout(() => updateError = false, 5000)
            })
    }

    $: original = transitions.find(it => it.status === status)
    $: updateCopy(original)
    $: description  = descriptionGiven(copy)
    $: formDisabled = working || !copy.enabled

</script>

<div class="transition">
    {#if loading}
        <i class="disabled notched circle loading inverted large icon"></i>
    {:else}
        <i  class="arrow alternate circle right inverted large icon" 
            class:disabled={!copy.enabled}
            on:click={() => active = true}></i>    
    {/if}
</div>
<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Transição Automática de Estado
            <span>{description}</span>
            <i class="ui red tiny label">Esta funcionalidade está liberada como teste beta</i>
        </div>
        <div class="content">
            <div class="ui toggle big checkbox" class:disabled={working}>
                <input type="checkbox" disabled={working} bind:checked={copy.enabled} on:change={console.log}>
                <label>Transição Automática</label>
            </div>
            <form class="ui form">
                <div class="field" class:disabled={formDisabled}>
                    <label>Url</label>
                    <input bind:value={copy.url}>
                </div>
                <div class="field" class:disabled={formDisabled}>
                    <label>Header</label>
                    <input bind:value={copy.header}>
                </div>
                <div class="field" class:disabled={formDisabled}>
                    <label>Token</label>
                    <input bind:value={copy.token}>
                </div>
            </form>
        </div>
        <div class="actions">
            {#if updateError}
                <i transition:fly="{{ x: -20, duration: 700 }}" class="ui red error label">erro ao salvar</i>
            {/if}
            <button class="ui black button" class:disabled={working} on:click={cancel}>
                Cancelar
            </button>
            <button class="ui green right labeled icon button"
                    class:disabled={working} 
                    class:loading={working} 
                    on:click={updateTransition}>
                Salvar <i class="check icon"/>
            </button>
        </div>
    </div>
</Modal>

<style>
   .transition {
        _border: 1px solid blue;
        position: absolute;
        right: 0;
    }

    .transition i.arrow.icon {
        cursor: pointer;
    }

    .header span {
        display: block;
        font-size: 70%;
        font-weight: lighter;
    }

    form {
        margin: 2em 1em;
    }
</style>
